import environment from 'environment';

export const CUSTOMER_URL = `${environment.app.serverApiUrl}/v1/customer`;
export const SHAREPOINT_URL = `${environment.app.serverApiUrl}/v1/sharepoint`;
